import { SearchDownloadModel, DownloadMode } from "./../models/search-download";
import { GenericDownloadView } from "./../../desktop/views/partials/generic-download";
import { MaterialFilterView } from "./material-filter";
import {backboneViewProperties} from "../../decorators/backbone-properties";

const template = require<string>("./search-download.html");
require("../styles/download-panel.less");

@backboneViewProperties({
    template: template,
    tagName: "div",
    id: "download-panel",
})
export class SearchDownloadView extends GenericDownloadView {
    public model: SearchDownloadModel;

    constructor(options?: any) {
        super(options);
        this.listenTo(this.model, "change:numDocsSelected", this.setSubmitButtonStatus);
        this.listenTo(this.model, "change:loading", this.loadingChanged);
        this.listenTo(this.model, "change:DownloadMode", this.downloadModeChanged);
        this.listenTo(this.model, "change:includeMetadata", this.includeMetadataChanged);
    }

    public loadingChanged() {
        const $el = this.$(".download-submit-button");

        if (this.model.loading) {
            $el.addClass("disabled");
            $(".js-download-toggle-label").text("Downloading...");
        } else {
            $(".js-download-toggle-label").text("Download");
            $el.removeClass("disabled");
        }
    }

    public downloadModeChanged() {
        let text;
        switch (this.model.DownloadMode) {
            case DownloadMode.DownloadSelected:
                text = "Use the checkboxes on each result below to select which documents you want to download";
                break;
            case DownloadMode.DownloadThisPage:
                text = "This will download the current page of results";
                break;
            case DownloadMode.DownloadTop50:
                const topResults = this.model.searchModel.TotalResults >= 50 ? 50 : this.model.searchModel.TotalResults;
                text = this.model.searchModel.TotalResults === 1 ? "This will download 1 result" : "This will download the first " + topResults + " results";
                break;
        }

        this.$(".explanatory-copy").text(text);
        this.setSubmitButtonStatus();
    }

    public includeMetadataChanged() {
        this.$("#download-include-metadata-checkbox").prop("checked", this.model.includeMetadata);
    }

    public onShow() {
        super.onShow();
        this.downloadModeChanged();
        this.$(".download-include-metadata-checkbox").prop("checked", this.model.includeMetadata);
        this.$(".radio-download-selected").trigger("click");
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events["click #download-include-metadata-checkbox"] = (e) => this.includeMetaDataClicked();
        events["click .toggle-download-checkboxes"] = (e) => this.toggleCheckboxesEnabled();
        events["change input[type=radio]"] = (e) => this.radioButtonChanged(e);
        events["click .download-submit-button"] = (e) => this.downloadButtonClicked(e);

        return events;
    }

    public downloadButtonClicked(e: JQueryEventObject) {
        if ($(e.currentTarget).hasClass("disabled") || $(e.currentTarget).hasClass("disallowed")) {
            return;
        }
        switch (this.model.DownloadMode) {
            case DownloadMode.DownloadSelected:
                this.downloadSelected(e);
                break;
            case DownloadMode.DownloadThisPage:
                this.downloadThisPage();
                break;
            case DownloadMode.DownloadTop50:
                this.downloadTop50();
                break;
        }
    }

    public radioButtonChanged(e) {
        const selected: string = $(e.currentTarget).val();
        const mode: DownloadMode = DownloadMode[selected];

        this.model.DownloadMode = mode;

        this.model.checkboxesEnabled = (mode === DownloadMode.DownloadSelected);
    }

    public includeMetaDataClicked() {
        this.model.includeMetadata = !this.model.includeMetadata;
    }

    public toggleCheckboxesEnabled() {
        this.model.checkboxesEnabled =  !this.model.checkboxesEnabled;
    }

    public downloadThisPage() {
        this.model.loading = true;
        this.model.getThisPageDownloadInfo().then((info) => {
            this.download(info);
        });
    }

    public downloadSelected(e: JQueryEventObject) {
        this.model.loading = true;
        this.model.getSelectedDownloadInfo().then((info) => {
            this.download(info);
        }).catch((error) => {
            this.model.loading = false;
        });
        this.model.clearSelectedDocKeys(); // This needs to be here to clear selections on other results pages
    }

    public downloadTop50() {
        return new Promise((resolve, reject) => {
            this.model.loading = true;
            this.model.getTop50DownloadInfo().then((info) => {
                this.download(info);
            });
        });
    }

    protected setSubmitButtonStatus() {
        const $el = this.$(".download-submit-button");
        this.isButtonEnabled() ? $el.removeClass("disabled") : $el.addClass("disabled");
    }

    private isButtonEnabled() {
        switch (this.model.DownloadMode) {
            case DownloadMode.DownloadSelected:
                return this.model.numDocsSelected > 0;
            case DownloadMode.DownloadThisPage:
                return this.model.searchModel.TotalResults > 0;
            case DownloadMode.DownloadTop50:
                return this.model.searchModel.TotalResults > 0;
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/views/search-download.ts